var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-pdf-app',{staticStyle:{"height":"100vh"},attrs:{"pdf":"https://file-examples-com.github.io/uploads/2017/10/file-example_PDF_1MB.pdf"}})}
var staticRenderFns = []

export { render, staticRenderFns }